module.exports = __webpack_public_path__ + "static/media/Original-Gretchen.b9fd7989.png";